app.factory('objectService', function(
    $rootScope,
    $http,
    $q,
    $cookies,
    designLineService,
    imageService,
    $auth
) {
    var reviewMode = $cookies.get('reviewMode'),
        _disabled = {
            groups: [],
            questions: [],
            alternatives: []
        },
        _object,
        _designline,
        _question_groups = [],
        _tillvalslinje,
        _chosenGroup,
        _saved_question_groups

    function getQuestionAnswer(question) {
        return question.alternatives.reduce(function(carry, alternative){
            if(carry !== null) return carry
            return alternative.id == question.answer ? alternative : null
        }, null)
    }

    function isAlternativeDisabled(alternative) {
        return _disabled.alternatives.indexOf(alternative.id) !== -1
    }

    function isQuestionDisabled(question) {
        return _disabled.questions.indexOf(question.id) !== -1
    }

    function isGroupDisabled(group) {
        //console.log('disabled groups isgroupdisabled: ', _disabled.groups)
        return _disabled.groups.indexOf(group.id) !== -1
    }

    function areAllQuestionsDisabledInGroup(group) {
        var allAreDisabled = true
        angular.forEach(group.questions, function(question){
            if(!isQuestionDisabled(question)) allAreDisabled = false
        })
        return allAreDisabled
    }

    return {
        demoMode: false,
        readOnly: false,
        previewMode: false,
        objectFetched: false,
        manager: null,
        buyers: [],
        currentConfigId : null,
        currentPresetId : null,
        question_groups: _question_groups,
        fetchObject: function() {
            var objectId = $auth.getPayload().sub
            return $http
                .get('/api/designwebben/object/'+objectId)
                .then(function(res) {
                    _object = res.data
                    var configuration = this.getCurrentConfiguration();
                    if(configuration && configuration.pivot.preset_id){
                        _designline = configuration.pivot.preset_id;
                        this.currentPresetId = configuration.pivot.preset_id;
                    }
                    if(configuration) {
                        this.currentConfigId = configuration.id;
                    }
                    this.manager = _object.manager
                    this.buyers = _object.buyers

                    this.demoMode = !!parseInt(_object.demo)
                    this.readOnly = this.getReviewMode() || this.demoMode
                    this.demoMode && debug('Demo mode on!');
                    this.readOnly && debug('Readonly mode on!');
                    this.objectFetched = true;
                }.bind(this))
        },
        clearObjectQuestions: function() {
            _question_groups = []
        },
        fetchObjectQuestions: function(configurationId,append) {
            if(!configurationId){
                if(!(configuration = this.getCurrentConfiguration())){
                    throw new Error('Missing configuration!')
                }

                configurationId = configuration.id
            }

            return $http
                .get('/api/designwebben/object/'+_object.id+'/configuration/' + configurationId)
                .then(function(res) {
                    console.log('_objectid för object', _object.id)
                    console.log('configurationId för object', configurationId)
                    console.log('res för object', res)
                    _tillvalslinje = res.data.tillvalslinje
                    if(append){
                        _question_groups = _question_groups.concat(res.data.question_groups)
                    } else {
                        _question_groups = res.data.question_groups
                    }
                    this.setDefaultAnswers()
                    this.updateDisabled()
                    this.updateDependencies()

                    return res.data.question_groups
                }.bind(this))
        },
        setDefaultAnswers: function(){
            var defaultAnswer,
                newAnswers = {}

            angular.forEach(_question_groups, function(group){
                angular.forEach(group.questions, function(question){
                    var tmpCurrentAnswer = question.answer
                    if(!hasValue(question.answer)){
                        question.answer = this.getDefaultAnswer(question)
                    }

                    if(hasValue(question.answer) && tmpCurrentAnswer !== question.answer){
                        newAnswers[question.id] = question.answer
                    }
                },this)
            },this)

            if(Object.keys(newAnswers).length){
                this.saveAnswers(newAnswers)
            }
        },
        updateDisabled: function() {
            _disabled.groups = []
            _disabled.questions = []
            _disabled.alternatives = []

            angular.forEach(_question_groups, function(group){
                angular.forEach(group.questions, function(question) {
                    //If question has an answer, check that answer for disablesAlternatives(alternatives that disables alternatives)
                    var questionAnswer = getQuestionAnswer(question)
                    if(!!questionAnswer && questionAnswer.disablesAlternatives.length){
                        angular.forEach(questionAnswer.disablesAlternatives, function(disabledAlternative_id) {
                            _disabled.alternatives.push(disabledAlternative_id)
                        })
                    }
                    //If the question has and answer, check for disables(answer that disables questions)
                    if(!!questionAnswer && questionAnswer.disablesQuestions.length){
                        angular.forEach(questionAnswer.disablesQuestions, function(disabledQuestion_id) {
                            _disabled.questions.push(disabledQuestion_id)
                        })
                    }
                },this)
            },this)

            angular.forEach(_disabled.alternatives, function(disabledAlternative_id){
                var disabledAlternative = this.findAlternativeById(disabledAlternative_id)
                if(!!disabledAlternative){
                    disabledAltQuestion = this.findQuestionById(disabledAlternative.question_id)
                    if(!!disabledAltQuestion && disabledAltQuestion.answer == disabledAlternative.id)
                        this.updateQuestionAnswer(disabledAltQuestion)
                }

            },this)

            angular.forEach(_question_groups, function(group) {
                if(areAllQuestionsDisabledInGroup(group))
                    _disabled.groups.push(group.id)
            },this)
        },
        updateDependencies: function() {
            angular.forEach(_question_groups, function(group) {
                group.dependencies = [];
            })

            angular.forEach(_question_groups, function(group) {
                angular.forEach(group.questions, function(question) {
                    angular.forEach(question.alternatives, function(alternative) {
                        if(!hasValue(question.answer) || question.answer != alternative.id) return;
                        angular.forEach(alternative.media.dependencies, function(dependency) {
                            var dependingGroup;
                            if(dependingGroup = getWhereId(_question_groups,dependency.data.question_group_id)){
                                dependingGroup.dependencies.push({
                                    url:            dependency.url,
                                    alternative_id: alternative.id,
                                })
                            }
                        });
                    });
                });
            })
        },
        updateQuestionAnswer: function(question, value) {
            console.log('question: ', question)
            var oldAnswer = question.answer

            if(hasValue(value)){
                question.answer = value
            } else {
                question.answer = this.getDefaultAnswer(question)
            }

            if(question.answer != oldAnswer){
                debug('Chosen answer: ', question.answer)
                this.saveAnswer(question, question.answer)
                this.updateDisabled()
                this.updateDependencies()
            }
        },
        getDefaultAnswer: function(question) {
            switch(question.type) {
                case QUESTION_TYPE.MULTIPLE:
                    for(var i = 0; i < question.alternatives.length; i++) {
                        if(!isAlternativeDisabled(question.alternatives[i])){
                            return question.alternatives[i].id
                        }
                    }
                    break;
                case QUESTION_TYPE.BOOLEAN:
                    return false
                    break;
            }

            return null
        },
        save: function(){
            if(this.readOnly) return;
            var answers = {},
                disabledQuestions = []

            angular.forEach(_question_groups, function(group){
                angular.forEach(group.questions, function(question){
                    if(!this.isQuestionDisabled(question)) answers[question.id] = question.answer
                },this)
            },this)

            var configuration = this.getCurrentConfiguration()

            return $http.post('/api/designwebben/object/'+_object.id+'/configuration/' + configuration.id, {
                'design_line': _designline,
                'answers':     answers,
                'disabled':    disabledQuestions,
            })
        },
        getObject: function() { return _object },
        getStatus: function() { return !!_object ? _object.status : 0 },
        getQuestionGroups: function() {
            debug('hämtar question groups', _question_groups)
            debug('hämtar chosen group', _chosenGroup)
            debug('hämtar $cookies', $cookies.get('chosenGroup'))
            return _question_groups
        },
        getSelectedDesignLine: function() { return designLineService.getDesignLineById(_designline) },
        changeDesignLine: function(designLineId) {
            _designline = designLineId
            this.saveDesignLine(designLineId)

            if(!designLineId) return
            $rootScope.designLineSelected = true;

            this.updateDesignLineQuestions()
        },
        updateDesignLineQuestions: function(){
            var newAnswers = {}

            angular.forEach(_question_groups, function(group){
                angular.forEach(group.questions, function(question){
                    var tmpCurrentAnswer = question.answer
                    angular.forEach(question.alternatives,function(alternative){
                        if(this.isAlternativeFromDesignLine(alternative)){
                            question.answer = alternative.id
                        }
                    },this)
                },this)
            },this)
            this.updateDisabled()

            if(Object.keys(newAnswers).length){
                this.saveAnswers(newAnswers)
            }
        },
        saveDesignLine: function(designLineId){
            if(this.readOnly) return;

            var configuration = this.getCurrentConfiguration()

            return $http.post('/api/designwebben/object/'+_object.id+'/designline/' + configuration.pivot.id,{
                'designline': designLineId
            });
        },
        saveAnswer: function(question, answer){
            if(this.readOnly) return;

            var configuration = this.getCurrentConfiguration()

            if(answer instanceof Object){
                answer = answer.id
            }

            return $http.post('/api/designwebben/object/'+_object.id+'/question/'+question.id+'/'+configuration.pivot.id,{
                'answer': answer,
            });
        },
        saveAnswers: function(answers){
            debug('Update answers: ',answers)
            if(this.readOnly) return;

            var configuration = this.getCurrentConfiguration()

            return $http.post('/api/designwebben/object/'+_object.id+'/questions/'+configuration.pivot.id,{
                'answers': answers,
            });
        },
        hasPendingStatus: function() {
            return _object.status == STATUS.EARLY_CHOICES_PENDING
                || _object.status == STATUS.DESIGN_CHOICES_PENDING
        },
        updateStatus: function() {
            if(!this.hasPendingStatus()) return

            if(this.readOnly) return

            $http.post('/api/designwebben/object/'+_object.id+'/status',{})
            .then(function(response){
            })
        },
        downloadPdf: function(){
            return $http.get('/api/object/get-pdf');
        },
        getReviewMode: function(){ return !!$cookies.get('reviewMode') },
        setReviewMode: function(mode){
            if(mode){
                $cookies.put('reviewMode',true);
                debug('Review mode on!');
            } else {
                $cookies.remove('reviewMode');
                debug('Review mode off!');
            }
            this.readOnly = mode || this.demoMode;
            this.readOnly && debug('Readonly mode on!');
        },
        setPreviewMode: function(previewMode) {
            debug('preview mode:', previewMode);
            this.previewMode = previewMode || false
        },
        getDemoMode: function(){
            return this.demoMode
        },
        isInEarlyChoices: function() {
            return _object.status == STATUS.EARLY_CHOICES_PENDING
        },
        isInDesignChoices: function() {
            return _object.status == STATUS.DESIGN_CHOICES_PENDING
        },
        calcPrice: function(type) {
            var sum = 0;
            angular.forEach(_question_groups, function(group){
                if(type && group.type != type) return
                angular.forEach(group.questions, function(question) {
                    if(isQuestionDisabled(question)) return
                    switch(question.type) {
                        case QUESTION_TYPE.MULTIPLE:
                            angular.forEach(question.alternatives, function(alternative) {
                                if(isAlternativeDisabled(alternative)) return
                                var price = alternative.data && alternative.data.price ? alternative.data.price : 0
                                if(alternative.id == question.answer && alternative.data) sum += parseInt(price)
                            })
                            break;
                        case QUESTION_TYPE.BOOLEAN:
                            if(question.answer){
                                var price = question.data && question.data.price ? question.data.price : 0
                                sum += parseInt(price)
                            }
                            break;
                    }
                })
            })
            return sum
        },
        isAlternativeFromDesignLine: function(alternative){
            if(isNaN(alternative)) alternative = alternative.id;
            var alternatives = this.getSelectedDesignLine().alternatives;

            return !!~alternatives.indexOf(alternative);
        },
        isAlternativeDisabled: function(alternative) {
            return isAlternativeDisabled(alternative)
        },
        isQuestionDisabled: function(question) {
            return isQuestionDisabled(question)
        },
        isGroupDisabled: function(group) {
            //debug('isgroupdisabled: id', group)
            //debug('func return isGroupDisabled: ', isGroupDisabled(group))
            return isGroupDisabled(group)
        },
        findQuestionGroupById: function(id) {
            for (var i = 0; i < _question_groups.length; i++) {
                if(_question_groups[i].id == id){
                    return _question_groups[i];
                }
            }
            return null;
        },
        findQuestionById: function(id) {
            for (var i = 0; i < _question_groups.length; i++) {
                for (var j = 0; j < _question_groups[i].questions.length; j++) {
                    if(_question_groups[i].questions[j].id == id){
                        return _question_groups[i].questions[j];
                    }
                }
            }
            return null;
        },
        findAlternativeById: function(id) {
            for (var i = 0; i < _question_groups.length; i++) {
                for (var j = 0; j < _question_groups[i].questions.length; j++) {
                    for (var k = 0; k < _question_groups[i].questions[j].alternatives.length; k++) {
                        if(_question_groups[i].questions[j].alternatives[k].id == id){
                            return _question_groups[i].questions[j].alternatives[k];
                        }
                    }
                }
            }
            return null;
        },
        hasEarlyChoices: function() {
            return !!_object.configurations.filter(function(conf){ return conf.data.type == CONFIGURATION_TYPE.EARLY_CHOICES}).length
        },
        hasDesignChoices: function() {
            return !!_object.configurations.filter(function(conf){ return conf.data.type == CONFIGURATION_TYPE.DESIGN_CHOICES}).length
        },
        getCurrentConfiguration: function(){
            var cnf, type;

            if(cnf = $auth.getPayload().cnf){
                return getWhereId(_object.configurations,cnf)
            }
            
            if(_object.status >= STATUS.EARLY_CHOICES_PENDING && _object.status <= STATUS.EARLY_CHOICES_COMPLETE){
                type = CONFIGURATION_TYPE.EARLY_CHOICES
            } else if(_object.status >= STATUS.DESIGN_CHOICES_PENDING && _object.status <= STATUS.DESIGN_CHOICES_COMPLETE){
                type = CONFIGURATION_TYPE.DESIGN_CHOICES
            }

            for (var i = 0; i < _object.configurations.length; i++) {
                if(_object.configurations[i].data.type == type){
                    return _object.configurations[i]
                }
            }

            return false
        },
        //New sigma "services"
        isTillvalslinje: function() {
            return _tillvalslinje
        },
        updateLinjeAnswer: function(groupId) {

            angular.forEach(_question_groups, function(group) {
            if(group.id === groupId){
                angular.forEach(group.questions, function(question){
                    this.updateQuestionAnswer(question, true)
                })
            }
            })
        },
        saveTillvalslinje: function(question, answer){
            if(this.readOnly) return;

            var configuration = this.getCurrentConfiguration()

            if(answer instanceof Object){
                answer = answer.id
            }

            return $http.post('/api/designwebben/object/'+_object.id+'/question/'+question.id+'/'+configuration.pivot.id,{
                'answer': answer,
            });
        },
        updateQuestionAnswer1: function(obj, groupId) {
            var currentThis = this
            var indexo = 0
            _saved_question_groups = _question_groups
            _disabled.groups = []

            angular.forEach(_question_groups, function(group, index) {
                if(group.id === groupId){
                    _chosenGroup = group
                    $cookies.remove('chosenGroup')
                    $cookies.put('chosenGroup', groupId)

                    angular.forEach(group.questions, function(question){
                        if(question.type != QUESTION_TYPE.MULTIPLE && question.changeable != 1) {
                            currentThis.updateQuestionAnswer(question, true)
                        }
                    },this)
                }
                else{
                    _question_groups[index].hidden = true
                    angular.forEach(group.questions, function (question){
                        currentThis.updateQuestionAnswer(question, false)
                    }, this)
                    if(indexo === 0){
                        _disabled.groups[indexo] = group.id
                        indexo++
                    }else{
                        _disabled.groups[indexo] = group.id
                    }
                }
            }, this)
            _question_groups = []
            _question_groups[0] = _chosenGroup
        },
        getTillvalslinje: function() {
            if($cookies('chosenGroup'))
            return _chosenGroup
        },
        switchLinje: function() {
            _question_groups = []
            _question_groups = _saved_question_groups
        },
        updateQuestionLinje: function(question, value) {
            if(question.changeable === 1) {
                var oldAnswer = question.answer

                if (hasValue(value)) {
                    question.answer = value
                } else {
                    question.answer = this.getDefaultAnswer(question)
                }

                if (question.answer != oldAnswer) {
                    this.saveAnswer(question, question.answer)
                    this.updateDisabled()
                    this.updateDependencies()
                }
            }
        },
    };
});
